import { client } from './experience';

export const useExperienceClient = () => {
  const VITE_RUNTIME_API_URL = import.meta.env.VITE_RUNTIME_API_URL as string | undefined;
  const { baseUrl } = client.getConfig();

  if (VITE_RUNTIME_API_URL && baseUrl !== VITE_RUNTIME_API_URL) {
    client.setConfig({ baseUrl: VITE_RUNTIME_API_URL });
  } else if (baseUrl !== '') {
    client.setConfig({ baseUrl: '' });
  }

  return client;
};
